import { RootState } from 'src/redux/createRootReducer'
import { ErrorDetailMap } from 'src/utils/error.utils'

export const selectEmailSentFromState = (state: RootState): boolean =>
  state.app.resetPassword.emailSent
export const selectEmailSendingFromState = (state: RootState): boolean =>
  state.app.resetPassword.emailSending
export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.resetPassword.topLevelError
export const selectErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined => state.app.resetPassword.errorDetailMap
